<template>
  <stormy-axios-error-dialog
    :show="show"
    :error-object="errorObject"
    :title="title"
    @cancel="onClose"
  />
</template>

<script setup>
import { closeDialog } from 'vue3-promise-dialog'
import { ref } from 'vue'
import { useProp } from '@/composables/useProp.js'

const show = ref(true)

defineProps({
  title: useProp(String, 'Löschen bestätigen'),
  errorObject: useProp(String)
})

const onClose = () => {
  console.log('onClose')
  show.value = false
  closeDialog(false)
}

</script>
